export default __webpack_public_path__ + "static/single_app_2-cb506387563b59795a63fc2cf0ff5e09.png";